import React from 'react';
import styles from './CarouselControls.module.scss';
import cx from 'classnames';
import { Icon } from '../Icon/Icon';

export type PrevNextProps = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  dark?: boolean;
  disabled?: boolean;
};

export type DotsProps = {
  onClick: (i: number) => void;
  wrapperClassName?: string;
  count: number;
  active: number;
};

const Prev = ({ onClick, className, dark, disabled }: PrevNextProps) => {
  const buttonStyles = cx(styles.controlButton, className, {
    [styles['controlButton--dark']]: dark,
  });

  return (
    <button
      className={buttonStyles}
      disabled={disabled}
      aria-label="carousel-previous"
      onClick={onClick}>
      <Icon type="leftChevron" />
    </button>
  );
};

const Next = ({ onClick, className, dark, disabled }: PrevNextProps) => {
  const buttonStyles = cx(styles.controlButton, className, {
    [styles['controlButton--dark']]: dark,
  });

  return (
    <button
      className={buttonStyles}
      disabled={disabled}
      aria-label="carousel-previous"
      onClick={onClick}>
      <Icon type="rightChevron" />
    </button>
  );
};

const Dots = ({ count, onClick, wrapperClassName, active }: DotsProps) => (
  <div className={cx(styles.dots, wrapperClassName)}>
    {[...Array(count).keys()].map(i => (
      <button
        key={i}
        onClick={() => onClick(i)}
        className={cx({ [styles.active]: i === active })}
        aria-label={`carousel-slide-${i}`}
      />
    ))}
  </div>
);

export const CarouselControls = {
  Prev,
  Next,
  Dots,
};
